const EN = {
  placeholders: {
    username: 'Username',
    password: 'Password',
    tagsEx: 'Brand name, Industry, ...',
    projSubProj: 'project/subproject',
    aoiName: 'AOI analysis name',
  },
  titles: {
    latestProjects: 'Latest projects',
    addMedias: 'Add media',
    newProject: 'New project',
    myProjects: 'My projects',
    allProjects: 'All projects',
    preview: 'Preview',
    noImage: 'No image',
    startAnalyze: 'You will start an analyze',
    youMustSelectImg: 'You must select an image before clicking on an icon',
    sort: 'Sort',
    display: 'Display',
    youWillDelete: 'You will delete this project | You will delete these projects',
    moveMedia: 'Move media',
    selectOrCreate: 'Select or create a project folder',
    aoiSelection: 'AOI selection',
    layerArea: 'Selected area(s)',
    tools: 'Selection tools',
    noImgSelect: 'No image selected',
    aoiNameRequired: 'AOI analysis name',
    polygon: 'Polygon',
    rectangle: 'Rectangle',
    circle: 'Circle',
    account: 'Account',
    kindOfProject: 'What kind of project is it ?',
    kindAddTags: 'Add tags for these images',
    deleteImgs: 'Are you sure you want to delete these image(s)/report(s) ?',
    sendAnalyzes: 'Are you sure you want to analyse the selected area(s) ?',
    badImg: 'Wrong format',
    downNoBasic: 'Please wait for the basic report to be available before downloading',
    aoiNoBasic: 'Please wait for the basic report to be available before doing an AOI analysis',
  },
  texts: {
    addAndRetry: 'Add media and retry',
    jobTitle: 'Job title',
    jobDescription: 'Job description',
    firstName: 'First Name',
    lastName: 'Last Name',
    userName: 'Username',
    email: 'E-mail',
    phone: 'Phone',
    address: 'Address',
    language: 'Language',
    infoCreateProject: 'If the project doesn\'t exist, it will be created',
    nbrImages: 'Number of image(s) analyzed ',
    projectType: 'Project type',
    tags: 'Tag(s)',
    destinationFolder: 'Destination folder',
    columns: 'Columns',
    defineAreasRequired: 'You have to define areas on these images to select these images. Then you can analyze them.',
    aoiNameRequired: 'The AOI analysis name is required for each image with selected area(s). Please enter a name.',
    noImgYet: 'There are no image yet.',
    createNewProj: 'Create a new',
    proj: 'project',
    subProj: 'subproject',
    addToParent: 'Add to a parent project',
    delReportBASIC: 'By deleting BASIC report, you will delete <strong>this image</strong> with <strong>ALL</strong> related reports.',
    delReportAOI: 'You will delete the report <strong>{name}</strong>',
    delReportALL: 'You will delete <strong>this image</strong> with <strong>ALL</strong> related reports !',
    delProjects: 'With its <strong>{nbr}</strong> medias',
    analyzeAOIName: 'AOI analysis name: <strong>{aoiName}</strong>',
    analyzeImgName: 'Image name: <strong>{imgName}</strong>',
    analyzeSelections :'Selection(s): <strong>{nbrSelections}</strong>',
    accountLevel: 'Subscryption type',
    consomation: 'Number of analysis this month',
    badImg: 'Sorry we can not upload your image(s) because it is not a jpeg or png file. Please retry with the right extension.',
  },
  buttons: {
    cancel: 'Cancel',
    next: 'Next',
    login: 'Log in',
    packaging: 'Packaging',
    retail: 'Retail',
    reflex: 'Reflex',
    add: 'Add',
    ad: 'Ad',
    natural:"Natural",
    web: 'Web',
    magazine: 'Magazine',
    leaflet: 'Leaflet',
    analyzeAll: 'Analyze all',
    back: 'Back',
    analyze: 'Analyze',
    delete: 'Delete',
    sort: 'Sort',
    size: 'View',
    download: 'Download',
    moveTo: 'Move to',
    aoi: 'AOI',
    close: 'Close',
    deleteAll: 'Delete all',
    move: 'Move',
    profile: 'Profile',
    logout: 'Logout',
    edit: 'edit',
    create: 'Create',
  },
  labels: {
    tags: 'Tags',
    chooseOrCreate: 'Choose/create Project',
    projectName: 'Project Name',
    parentProj: 'Parent project',
  },
  errors: {
    fieldRequired: 'This field is required',
    nameProjRequired: 'The name of the new project is required',
    childProjExist: 'This child project name alredy Exist.',
    parentProjExist: 'This project name alredy Exist. Chose a parent or rename',
  },

}

export default EN;